<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">

          <div class="management-header">

          </div>
          <div class="serch-wapper" v-loading="loading">
            <div class="water-table" v-for="(itemTable,indexTable) in historyList" :key="indexTable" >
              <div class="history-time" style="width:20%">
                {{ itemTable.create_time }}
              </div>
              <el-button
                type="primary"
                @click="manageData(itemTable.content)" class="manage-btn">
                <router-link :to="{ name: 'internationalWatersManagement',query:{ countryId: countryId, reManage: 1 } }" target="_blank">
                  再次配置
                </router-link>
              </el-button>
              <div class="water-head">
                <el-col class="water-name-common" :span="4">姓名</el-col>
                <el-col class="water-name-common" :span="2" v-for="header in tableHeader" :key="header.id">
                  {{ header.name }}
                </el-col>
              </div>
              <div class="water-content-list">
                <el-col class="water-tr" v-for="(item,index) in itemTable.content" :key="index">
                  <!-- <el-col :span="2" class="water-td">{{ item.crmsayer }}</el-col> -->
                  <el-col :span="4" class="water-td">{{ item.sayerName }}</el-col>
                  <el-col :span="2" class="water-td" v-for="header in tableHeader" :key="header.id">
                    {{ item[header.key] }}
                  </el-col>
                </el-col>
              </div>
            </div>

            <div class="pagePagination" style="display:none">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pagination.currentPage"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.historyTotal">
              </el-pagination>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { jmDictSelect } from '@/components/tool';
import lockr from 'lockr';

export default {
  data() {
    return {
      countryId: null,
      historyList: [],
      tableHeader: null,
      tableData: [],
      pagination: {
        currentPage: 3, // 当前页数
        historyTotal: 100, // 总共条目数
        pageSize: 5, // 每页条目
      },
      loading: true,
    };
  },
  components: {
    jmDictSelect
  },
  methods: {
    /**
     * 翻页配置
     */
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    /**
     * 获取分配历史列表
     */
    distributionLog(id) {
      this.$http._post({ url: '/index/international_waters/distributionLog', data: { countryId: id } }).then(({ data }) => {
        if (data.historyList && data.historyList.length) {
          this.tableHeader = data.rulesTable;
          this.historyList = data.historyList;
        } else {
          this.$message({
            type: 'info',
            message: '当前国家无分配记录'
          });
        }
        this.loading = false;
      });
    },
    /**
     * 重新分配
     */
    manageData(assignmentData) {
      lockr.set('reManage', assignmentData);
    },
  },
  created() {
    this.countryId = this.$route.query.countryId;
    this.distributionLog(this.countryId);
  },
};
</script>

<style lang="less" scoped>
  .water-table{
      width: 90%;
      height: auto;
      overflow: hidden;
      margin-bottom: 20px;
      margin-top: 20px;
      margin: 20px auto;
      position: relative;
      .manage-btn{
          position: absolute;
          right: 0;
          top: 0;
      }
      .water-head{
          width: 100%;
          height: 50px;
          line-height: 50px;
          background: #01142d;
          margin-top:15px;
          .water-name-common{
              border-right: 1px solid #fff;
              color: #fff;
              font-size: 14px;
              text-align: center;
          }
      }
      .water-content-list{
          width: 100%;
          height: 50px;
          .water-tr{
              width: 100%;
              height: 100%;
              border: 1px solid #ccc;
              border-top: 0px;
                border-right: 0px;
              .water-td{
                  height: 100%;
                  border-right: 1px solid #ccc;
                  text-align: center;
                  line-height: 50px;
              }
          }
      }
  }
  .history-time{
    color: #fff;
    background: #01142d;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
  .pagePagination{
    float: right;
  }
</style>
